import {
  Card,
  CardContent,
  Grid,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import React from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
export default function PurchaseItemCard({
  index,
  item,
  arr,
  setPurchaseItemsArr,
}) {
  console.log("item ", item);
  return (
    <Card
      sx={{
        width: "100%",
        m: 0,
        mt: "10px",
        p: 0,
        cursor: "pointer",
        ":hover": {
          bgcolor: "#2892ba17",
        },
      }}
    >
      <CardContent sx={{ p: "0px !important" }}>
        <Grid
          container
          alignItems="center"
          sx={{
            py: 0.5,
            px: { xs: 1, sm: 2 }, // padding for small screens
          }}
        >
          {/* Item Description */}
          <Grid item xs={4} sm={5}>
            <Typography
              sx={{
                fontSize: { xs: "10px", sm: "16px" },
                fontWeight: 600,
                ml: { xs: "0px", sm: "45px" },
                wordBreak: "break-word", // handle overflow
              }}
            >
              {item?.description}
            </Typography>
          </Grid>

          {/* Quantity */}
          <Grid item xs={2}>
            <Typography
              sx={{
                textAlign: "right",
                fontWeight: 600,
                fontSize: { xs: "10px", sm: "16px" },
              }}
            >
              {item?.quantity}
            </Typography>
          </Grid>

          {/* Rate */}
          <Grid item xs={3} sm={2}>
            <Typography
              sx={{
                fontSize: { xs: "10px", sm: "16px" },

                textAlign: "right",
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                fontWeight: 600,
              }}
            >
              <CurrencyRupeeIcon
                sx={{ fontSize: { xs: "10px", sm: "16px" }, mr: 0.3 }}
              />
              {item?.price?.toFixed(2)}
            </Typography>
          </Grid>

          {/* Total */}
          <Grid item xs={3} sm={2}>
            <Typography
              sx={{
                fontSize: { xs: "10px", sm: "16px" },

                textAlign: "right",
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                fontWeight: 600,
              }}
            >
              <CurrencyRupeeIcon
                sx={{ fontSize: { xs: "10px", sm: "16px" }, mr: 0.2 }}
              />
              {item?.amount?.toFixed(2)}
            </Typography>
          </Grid>

          {/* Delete Icon */}
          <Grid
            item
            xs={12}
            sm={1}
            sx={{
              textAlign: { xs: "right", sm: "center" },
              mt: { xs: 1, sm: 0 },
            }}
          >
            <DeleteIcon
              sx={{ cursor: "pointer", fontSize: { xs: "18px", sm: "20px" } }}
              onClick={() => {
                const updated = [...arr];
                updated.splice(index, 1);
                setPurchaseItemsArr(updated);
              }}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
